import { ConfigProvider } from 'antd';
import type { ConfigProviderProps } from 'antd/es/config-provider';
import { FC, ReactNode } from 'react';
import { useLocale } from 'hooks/use-language-select';
import { getAntdLocale } from './antd-locale';

interface AntdLocaleProviderProps extends Omit<ConfigProviderProps, 'locale'> {
  children: ReactNode;
}

export const AntdLocaleProvider: FC<AntdLocaleProviderProps> = ({
  children,
  ...configProps
}) => {
  const { locale } = useLocale();
  const antdLocale = getAntdLocale(locale || 'en');

  return (
    <ConfigProvider locale={antdLocale} {...configProps}>
      {children}
    </ConfigProvider>
  );
};
